export default __webpack_public_path__ + "static/media/twitter.fbc3caef.png";